import * as React from "react";
const SvgCloseCircleFill20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-1.414-3-3L5.586 7l3 3-3 3L7 14.414l3-3 3 3L14.414 13l-3-3 3-3L13 5.586l-3 3Z",
      clipRule: "evenodd"
    })
  );
export default SvgCloseCircleFill20Px;
